import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <Section className="bg-[#faf8f5]" data-id="element-68">
      <div className="text-center max-w-3xl mx-auto mb-8" data-id="element-69">
        <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-70">
          Comparativa rápida
        </h2>
        <p className="text-lg text-[#5a5a5a]" data-id="element-71">
          Esto no compite con tu fuerza de voluntad. La reemplaza por un
          sistema.
        </p>
      </div>

      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-xl overflow-hidden border border-[#2c4a2c]/10" data-id="element-72">
        <div className="grid grid-cols-2" data-id="element-73">
          <div className="bg-[#2c4a2c] text-white p-4 text-center" data-id="element-74">
            <h3 className="font-bold text-base md:text-lg" data-id="element-75">Energía Alta</h3>
            <p className="text-xs opacity-80" data-id="element-76">(Mediterránea)</p>
          </div>
          <div className="bg-[#f0f0f0] text-[#5a5a5a] p-4 text-center" data-id="element-77">
            <h3 className="font-bold text-base md:text-lg" data-id="element-78">
              Alternativas típicas
            </h3>
            <p className="text-xs opacity-80" data-id="element-79">
              (Dietas, café, fuerza voluntad)
            </p>
          </div>
        </div>

        <div className="divide-y divide-gray-100" data-id="element-80">
          {[{
          us: 'Sistema diario (3 bloques)',
          them: 'Café/dulce (parche)'
        }, {
          us: 'Plantillas y trackers',
          them: 'Ensaladas sin estructura'
        }, {
          us: 'Mediterráneo real, adaptable',
          them: 'Prohibiciones'
        }, {
          us: 'Sin extremos',
          them: '"Comer lo que haya"'
        }].map((row, index) => <div key={index} className="grid grid-cols-2" data-id="element-81">
              <div className="p-4 flex items-center gap-2 bg-[#2c4a2c]/5" data-id="element-82">
                <div className="bg-[#2c4a2c] rounded-full p-1 shrink-0" data-id="element-83">
                  <Check className="w-3 h-3 text-white" data-id="element-84" />
                </div>
                <span className="font-medium text-[#2c4a2c] text-sm" data-id="element-85">
                  {row.us}
                </span>
              </div>
              <div className="p-4 flex items-center gap-2 bg-white" data-id="element-86">
                <div className="bg-gray-200 rounded-full p-1 shrink-0" data-id="element-87">
                  <X className="w-3 h-3 text-gray-500" data-id="element-88" />
                </div>
                <span className="text-[#5a5a5a] text-sm" data-id="element-89">{row.them}</span>
              </div>
            </div>)}
        </div>
      </div>

      <div className="mt-8 text-center" data-id="element-90">
        <Button size="lg" data-id="element-91">Elegir el sistema</Button>
        <button onClick={scrollToPricing} className="mt-3 block mx-auto text-sm text-white bg-[#c45d3a] hover:bg-[#a84a2a] px-6 py-3 rounded-lg cursor-pointer transition-all font-medium shadow-xl shadow-[#c45d3a]/40 hover:shadow-2xl hover:shadow-[#a84a2a]/50 active:scale-[0.98] hover:scale-[1.01]" data-id="element-92">
          Paga una vez, reutiliza siempre → $6.39
        </button>
      </div>
    </Section>;
}